function isoToDate(iso: string): Date {
  return new Date(iso + "T00:00:00")
}

/** "2026-10-01" → "October" */
export function monthName(iso: string): string {
  return isoToDate(iso).toLocaleDateString("en-US", { month: "long" })
}

/** "2026-10-01" → "Oct", or "Oct 2026" when withYear. */
export function monthShort(iso: string, withYear = false): string {
  return isoToDate(iso).toLocaleDateString("en-US", withYear ? { month: "short", year: "numeric" } : { month: "short" })
}

/** Whole percent of part over whole; null when whole is missing or 0. */
export function percentOf(part: number, whole: number | null): number | null {
  if (whole == null || whole === 0) return null
  return Math.round((part / whole) * 100)
}

/** "1 day", "12 days" */
export function days(n: number): string {
  return `${n} ${n === 1 ? "day" : "days"}`
}
